import React from 'react';
import { connect } from 'react-redux';

import Join from './Join';
import List from './List';
import * as projectsDuck from '../../projects/duck';

class AddProjectsToUser extends React.Component {
  componentDidMount() {
    this.props.requestProjectsDataIfNeeded();
  }

  render() {
    const { user, projects, projectsType, onSuccess } = this.props;
    const showList = this.props.showJoinedProjectsList;

    return (
      <React.Fragment>
        <Join
          onSuccess={onSuccess}
          user={user}
          projects={projects}
          projectsType={projectsType}
        />
        {showList && (
          <List user={user} projects={projects} projectsType={projectsType} />
        )}
      </React.Fragment>
    );
  }
}

AddProjectsToUser.defaultProps = {
  showJoinedProjectsList: true,
};

const mapDispatchToProps = {
  requestProjectsDataIfNeeded: projectsDuck.requestDataIfNeeded,
};

const mapStateToProps = ({ user, projects }) => {
  return {
    user,
    projects,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddProjectsToUser);



// WEBPACK FOOTER //
// ./src/user/join-projects/index.js